import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { SesConfigurationState } from '../reducers/ses-configuration.reducer';
import * as selectors from '../selectors/ses-configuration.selectors';

@Injectable()
export class SesConfigurationFacadeService extends FacadeService {
  constructor(public override store: Store<SesConfigurationState>) {
    super(store);
  }

  // OBSERVABLES

  nameSes$ = this.storeSelect(selectors.getNameSes);
  isActiveSes$ = this.storeSelect(selectors.getStatusSes);
  disableNameValue$ = this.storeSelect(selectors.getDisableNameValue);
  integrationConfHelpTextStatus$ = this.storeSelect(selectors.getIntegrationConfHelpTextStatus);
  showNameErrorMsg$ = this.storeSelect(selectors.getShowNameErrorMsg);
  lookBackDaysSes$ = this.storeSelect(selectors.getLookBackDaysSes);
  showLookBackDaysErrorMsg$ = this.storeSelect(selectors.getShowLookBackDaysErrorMsg);
  campaignReportingHelpTextStatus$ = this.storeSelect(selectors.getCampaignReportingHelpTextStatus);
  senderNamesSes$ = this.storeSelect(selectors.getSenderNamesSes);
  senderEmailAddressesSes$ = this.storeSelect(selectors.getSenderEmailAddressesSes);
  configurationSetsSes$ = this.storeSelect(selectors.getConfigurationSetsSes);
  showUpdateBtn$ = this.storeSelect(selectors.getShowUpdateBtn);
  showCancelBtn$ = this.storeSelect(selectors.getShowCancelBtn);
  sesDataAreValid$ = this.storeSelect(selectors.getSesDataAreValid);
  showSenderNamesErrorMsg$ = this.storeSelect(selectors.getShowSenderNamesErrorMsg);
  showSenderEmailsErrorMsg$ = this.storeSelect(selectors.getShowSenderEmailsErrorMsg);
  showConfSetsErrorMsg$ = this.storeSelect(selectors.getShowConfSetsErrorMsg);

  // OBSERVABLE'S VALUES

  get nameSes() {
    return this.storeSnapshot(this.nameSes$);
  }

  get statusSes() {
    return this.storeSnapshot(this.isActiveSes$);
  }

  get lookBackDaysSes() {
    return this.storeSnapshot(this.lookBackDaysSes$);
  }

  get senderNamesSes() {
    return this.storeSnapshot(this.senderNamesSes$);
  }

  get senderEmailAddressesSes() {
    return this.storeSnapshot(this.senderEmailAddressesSes$);
  }

  get configurationSetsSes() {
    return this.storeSnapshot(this.configurationSetsSes$);
  }

  get showUpdateBtn() {
    return this.storeSnapshot(this.showUpdateBtn$);
  }

  get sesDataAreValid() {
    return this.storeSnapshot(this.sesDataAreValid$);
  }

  get showSenderNamesErrorMsg() {
    return this.storeSnapshot(this.showSenderNamesErrorMsg$);
  }

  get showSenderEmailsErrorMsg() {
    return this.storeSnapshot(this.showSenderEmailsErrorMsg$);
  }

  get showConfSetsErrorMsg() {
    return this.storeSnapshot(this.showConfSetsErrorMsg$);
  }

  getSesBody() {
    const sesBody = {
      integrationCode: this.nameSes,
      deleted: this.statusSes,
      integrationConfig: {
        integrationSystem: 'AWS_SES',
        integrationDisplayName: this.nameSes,
        campaignReportingConfiguration: { lookbackDays: this.lookBackDaysSes },
        senderNames: this.senderNamesSes,
        senderEmailAddresses: this.senderEmailAddressesSes,
        configurationSets: this.configurationSetsSes,
      },
    };

    return sesBody;
  }
}
